import React from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import CopyrightInput from '@/components/common/CopyrightInput';
import { buildPhonographicCopyrightLine } from '@/components/common/ProductUtilities';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  phonographicCopyrightYearError: string | undefined;
  phonographicCopyrightLineError: string | undefined;
  handleAlbumMetaData: (field: string, value: string) => void;
};

export default function PhonographicCopyrightLineFormGroup({
  album,
  readonly,
  phonographicCopyrightYearError,
  phonographicCopyrightLineError,
  handleAlbumMetaData,
  fieldValidationState,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.pLine"
      hasErrors={
        !!phonographicCopyrightYearError || !!phonographicCopyrightLineError
      }
    >
      <CopyrightInput
        id={'phonographicCopyrightLine'}
        labelText={t('product.editProduct.pline')}
        linePlaceholderLabelText={t('product.editProduct.copyright_owner')}
        year={album.albumMetaData?.phonographicCopyrightYear}
        onYearChange={(year) =>
          handleAlbumMetaData('phonographicCopyrightYear', `${year || ''}`)
        }
        line={album.albumMetaData?.phonographicCopyrightLine}
        onLineChange={(line) =>
          handleAlbumMetaData('phonographicCopyrightLine', line || '')
        }
        yearErrorMessage={phonographicCopyrightYearError}
        lineErrorMessage={phonographicCopyrightLineError}
        yearValidationState={fieldValidationState?.(
          'PhonographicCopyrightYear'
        )}
        lineValidationState={fieldValidationState?.(
          'PhonographicCopyrightLine'
        )}
        displayLineBuilder={buildPhonographicCopyrightLine}
        readonly={readonly}
        labelClassName="col-sm-3 form-label"
        inputPairClassName="col-sm-6 pair-input-container padding-left-0"
        errorMessageClassName="col-sm-2 popUp-container"
      />
    </FormGroupWithTooltip>
  );
}
